var React = require('react');

function Truck2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 317H240.553V253.963H105.807V253.509C127.511 230.381 160.972 211.333 188.554 188.658C216.136 167.343 240.101 142.401 240.101 99.3176C240.101 44.4435 199.858 0 125.25 0C76.8685 0 43.4081 17.2332 25.7735 42.6295C10.852 63.0372 4.52167 85.2589 4.52167 121.539H75.9641C76.4163 100.225 80.938 86.166 89.9813 75.7354C97.6682 66.2117 108.972 61.6767 123.442 61.6767C149.667 61.6767 163.685 78.0029 163.685 102.039C163.685 117.458 155.998 129.249 143.337 140.587C118.92 162.355 82.7466 185.03 54.7123 209.066C23.9649 234.916 0.904334 264.847 0 317Z","fill":"white"}));
}

Truck2.defaultProps = {"width":"241","height":"317","viewBox":"0 0 241 317","fill":"none"};

module.exports = Truck2;

Truck2.default = Truck2;
